/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export enum ReportFormControl {
	ReportType = 'reportType',
	AsOfDate = 'asOfDate',
	EndDate = 'endDate',
	NumberOfWeeks = 'numberOfWeeks',
	Roles = 'roles',
	Plans = 'plans',
	Locations = 'locations',
	IncludeCompleted = 'includeCompleted',
	OnlyLate = 'onlyLate',
	FilterByCustomFieldsToggle = 'filterByCustomFieldsToggle',
	CustomField1 = 'customField1',
	CustomField2 = 'customField2',
	CustomField3 = 'customField3',
	TimeScale = 'timeScale',
	PpcFormat = 'ppcFormat',
	SortBy = 'sortBy',
	GroupBy = 'groupBy',
	SortGroupsBy = 'sortGroupsBy',
	BreakUpBy = 'breakUpBy',
	CSVExportType = 'csvExportType',
	CSVPlan = 'csvPlan',
	TicketTypes = 'ticketTypes',
	IncludePullTickets = 'includePullTickets',
	ExternalLinkage = 'externalLinkage',
	ExportFormatType = 'exportFormatType',
	ExportFormatTemplate = 'exportFormatTemplate',
	Swimlanes = 'swimlanes',
	CustomFields = 'customFields',
	WbsCodeFilterConfig = 'wbsCodeFilterConfig',
	IncludeWBSCodeFilterToggle = 'includeWBSCodeFilterToggle',
	WbsGroupingLevel = 'wbsGroupingLevel',
	ArchivedPlansDropDown = 'archivedPlansDropDown',
}

// This is used by the function below it
export function isLayoutControl(control: ReportFormControl) {
	switch (control) {
		case ReportFormControl.PpcFormat:
		case ReportFormControl.TimeScale:
		case ReportFormControl.SortBy:
		case ReportFormControl.GroupBy:
		case ReportFormControl.SortGroupsBy:
		case ReportFormControl.BreakUpBy:
			return true;
		default:
			return false;
	}
}

// This is used when the user chooses a new Report Type in the Reports UI.
// The "controls" argument describes which ReportFormControl to display
// for the newly chosen report type.
// This function returns true if any of the controls for the new report type
// are "layout" controls which are put into the Layout expansion panel of
// the Reports UI.  If no such layout controls apply to the new report type,
// then this function returns "false" and the entire Layout expansion panel
// can be omitted from the Reports UI.
export function hasActiveLayoutControl(controls: { [key in ReportFormControl]: boolean }) {
	for (const key in controls) {
		if (controls[key] && isLayoutControl(key as ReportFormControl)) {
			return true;
		}
	}
	return false;
}
